import { FC } from 'react';
import classes from './TableOutput.module.scss';
import { Props } from './types';
import clsx from 'clsx';

export const TableOutput: FC<Props> = ({ processingData, formData }) => {
  if (!processingData || !formData) {
    return null;
  }

  return (
    <>
      <div className={classes.retailerData}>
        <div className={classes.retailer}>{processingData.receipt?.['retailer-name']}</div>
        <div className={classes.dataContainer}>
          {(processingData.receipt?.['purchase-date']) && <div>Purchase Date: {processingData.receipt?.['purchase-date']}</div>}
          {(processingData.receipt?.['purchase-time']) && <div>Purchase Time: {processingData.receipt?.['purchase-time']}</div>}
          {(processingData.receipt?.phone) && (<div>{`Phone number: ${processingData.receipt?.phone}`}</div>)}
          {(processingData.receipt?.address) && <div>Store Address: {processingData.receipt?.address}</div>}
        </div>
      </div>
      <div className={classes.tableContainer}>
        <table cellSpacing="0">
          <thead>
            <tr>
              <th className={classes.itemCell}>Item</th>
              <th className={clsx(classes.cell, classes.typeCell)}>Type</th>
              <th className={classes.cell}>Price</th>
              <th className={classes.cell}>Quantity</th>
              <th className={classes.totalCell}>Total</th>
            </tr>
          </thead>
          <tbody>
          {processingData?.receipt?.items && processingData.receipt.items.map((item, i) => (
            <tr key={`${item.text}-${item.code}-${i}`} className={item['product-of-interest'] ? classes.ioiRow : undefined }>
              <td className={classes.itemCell}>{item.text}</td>
              <td className={clsx(classes.cell, classes.typeCell)}>{item.type}</td>
              <td className={classes.cell}>{item.price?.amount}</td>
              <td className={classes.cell}>{item.quantity?.value}</td>
              <td className={classes.totalCell}>{item.total?.amount}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
      <div className={classes.totalContainer}>
        <div className={classes.totalRow}>
          <div className={classes.totalLabel}>discount ({processingData.receipt?.total?.currency})</div>
          <div className={classes.totalValue}>{processingData.receipt?.discounts?.total || 0}</div>
        </div>
        <div className={classes.totalRow}>
          <div className={clsx(classes.totalLabel, classes.bold)}>Total ({processingData.receipt?.total?.currency})</div>
          <div className={classes.totalValue}>{processingData.receipt?.total?.amount}</div>
        </div>
      </div>
    </>
  );
};
